module.exports = __webpack_public_path__ + "static/media/bg-a3.5de4267a.png";